module.exports = __webpack_public_path__ + "assets/dashboard-icon-totalSales-selected.f4012ae3.svg";